export default [
    // packages ordered by priority
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFPTTF",
    "PFTTF",
    "HS",
    "PF",
    "PFP",
];
